angular.module("digitalLeasing.module").component("plafondLoading", {
  templateUrl: "ng/components/digitalLeasing/plafondLoading/plafondLoading.view.html",
  bindings: {
    model: "=", //preventivo
    financial: "=",
    vendor: "<",
    customer: "<",
    validateRecipientsClient: "&",
    invalidateRecipientsClient: "&"
  },
  controllerAs: "plafondLoadingCtrl",
  controller: PlafondLoadingController
});

function PlafondLoadingController() {
  var self = this;

  self.$onInit = function () {
      jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("scrollTo", 0); //posiziona la scollBar in top ad ogni cambio vista
  };

  var handlechange = function (property, value) {
    self.model[property] = value;
  };

  self.handleStructureChange = function (preventivo) {
    handlechange("preventivo", preventivo);  
  };

  self.handleRecCliChange = function(validate){
    if(validate){
      self.validateRecipientsClient();
    }else{
      self.invalidateRecipientsClient();
    }
  }

}